/* unplugin-vue-components disabled */import script from "./NoticeBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeBar.vue?vue&type=script&setup=true&lang=js"

import "./NoticeBar.vue?vue&type=style&index=0&id=23316faa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23316faa"]])

export default __exports__